import { FormGroup } from '@angular/forms';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CambiarContraseniaService {

  constructor(private http: HttpClient) { }

  @Output() msjContrasenia = new EventEmitter();

  sendContrasenia(formPW: FormGroup): Observable<any>{
    return this.http.post(`${environment.urlApi}actualizarPassword/updatePassword`,formPW);
  }   
}
